import { selectRfs } from '@/store/state/rfs/rfs.selectors';
import { useAppSelector } from '@/store/store';
import { isDefined } from '@sgme/fp';
import { SgDatePicker } from '@sgme/ui';
import { addBusinessDays, addDays, subDays } from 'date-fns';
import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

type CallabilityStartProps = {
  date: string | undefined;
  onChange: (date: string) => void;
  disabled?: boolean;
};

export const CallabilityStart = ({ date, onChange, disabled = false }: CallabilityStartProps) => {
  const { date: maturityDate } = useAppSelector(selectRfs);

  const spot = useMemo(() => addBusinessDays(new Date(), 1).getTime(), []);
  const oneDayBeforeMaturityDate = useMemo(() => subDays(maturityDate, 1).getTime(), [maturityDate]);

  const handleChange = (date: string | undefined): void => {
    if (date) {
      onChange(date);
    }
  };

  return (
    <div className="mt-12px">
      <div className="fw-medium text-secondary mb-4px">
        <FormattedMessage id="trader.checkbox.AmericanForward.callabilityDate.description" />
      </div>
      <SgDatePicker
        showClearButton={false}
        e2e="american-forward-check-date"
        selectionType="single"
        values={isDefined(date) ? [date] : []}
        onChange={handleChange}
        isDisabled={disabled}
        disablePresets={`sundays ,saturdays, before:${spot}, after:${oneDayBeforeMaturityDate}`}
        appendTo=""
      />
    </div>
  );
};
